import store from '@/store';
import axios from 'axios';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Mutations, Endpoints } from '@/ts/store/Constants';
import DemographicTenants from '@/ts/DemographicTenants';
import { DemographicTenant } from '@/ts/HococoInterfaces';
import ErrorResponse from '@/ts/ErrorResponse';

@Module({name: 'UnitGroupingCharts', namespaced: true})
export default class UnitGroupingCharts extends VuexModule {
    public unitGroupingTenantsDemographicData: DemographicTenants[] = [];
    public tenantsDemographicFlayOutVisibility: boolean = false;

    @Mutation
    public RESET_UNIT_GROUPING_CHARTS_STORE_STATE() {
        this.unitGroupingTenantsDemographicData  = [];
        this.tenantsDemographicFlayOutVisibility = false;
    }

    get getUnitGroupingTenantsDemographicData(): DemographicTenants[] {
        return this.unitGroupingTenantsDemographicData;
    }

    get getTenantsDemographicFlayOutVisibility(): boolean {
        return this.tenantsDemographicFlayOutVisibility;
    }

    @Action
    public FETCH_UNIT_GROUPING_TENANTS_DEMOGRAPHIC(groupingId: number) {
        axios.get(Endpoints.Admin.PropertyGroupings.GROUPINGS_TENANTS(groupingId))
            .then((response) => {
                store.commit(Mutations.SET_UNIT_GROUP_TENANTS_DEMOGRAPHIC_DATA, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Mutation
    public SET_UNIT_GROUP_TENANTS_DEMOGRAPHIC_DATA(demographicData: DemographicTenant[]) {
        store.commit(Mutations.RESET_UNIT_GROUP_TENANTS_DEMOGRAPHIC_DATA);

        for (const demographicDataItem of demographicData) {
            this.unitGroupingTenantsDemographicData.push(new DemographicTenants(
                demographicDataItem.gender,
                demographicDataItem.age,
                demographicDataItem.socialClubs,
                demographicDataItem.educations,
            ));
        }
    }

    @Mutation
    public SET_TENANTS_DEMOGRAPHIC_FLAYOUT_VISIBILITY(visibility: boolean) {
        this.tenantsDemographicFlayOutVisibility = visibility;
    }

    @Mutation
    public RESET_UNIT_GROUP_TENANTS_DEMOGRAPHIC_DATA() {
        this.unitGroupingTenantsDemographicData = [];
    }
}

